import client from "./clients/portalClient";

const getAllDebtors = () => client.get(`/project_debtors/dashboard`);
const getDebtors = () => client.get(`/project_debtors`);
const getDebtor = (id) => client.get(`/project_debtors/${id}`);
const putDebtor = (id, data) => client.put(`/project_debtors/${id}`, data);

const getInvoices = (cat) => client.get(`/project_invoices?data=${cat}`);
const getInvoicesByDate = (before, after) => client.get(`/project_invoices?data=open${before ? `&before=${before}` : ""}${after ? `&after=${after}` : ""}`);
const getInvoice = (id) => client.get(`/project_invoices/${id}`);
const editInvoice = (id, data) => client.put(`/project_invoices/${id}`, data);
const getInvoiceComments = (id) => client.get(`/project_invoices/${id}/comments`);
const deleteInvoiceComment = (id, cId) => client.delete(`/project_invoices/${id}/comments/${cId}`);
const addInvoiceComment = (id, data) => client.post(`/project_invoices/${id}/comments`, data);


const debtorsApi = {
    getAllDebtors,
    getDebtors,
    getDebtor,
    putDebtor,

    getInvoices,
    getInvoicesByDate,
    getInvoice,
    editInvoice,
    getInvoiceComments,
    deleteInvoiceComment,
    addInvoiceComment

};

export default debtorsApi;